<template>
  <div :style="{width: '100%'}" :class="style.answer" ref="answerForm">
    <div
      v-if="getContactsQuiz?.contacts?.name?.bool"
      :class="style.printContacts"
    >
      <span>Введите имя</span>
      <input
        name="contacts-name"
        @input="answerInputF($event)"
        :placeholder="getPlaceholder('name')"
        type="text"
      />
    </div>
    <div
      v-if="getContactsQuiz?.contacts?.email?.bool"
      :class="style.printContacts"
    >
      <span>Введите email</span>
      <input
        name="contacts-email"
        @input="answerInputF($event)"
        :placeholder="getPlaceholder('email')"
        type="email"
      />
    </div>
    <div
      v-if="
        getBoolConnectionList() &&
        getContactsQuiz?.contacts?.connectionList?.bool
      "
      :class="style.selectConnection"
    >
      <span>Выберите способ связи</span>
      <section :class="style.connections">
        <CheckBoxRadioButton
          v-if="getContactsQuiz?.contacts?.phone?.bool"
          :answer="answer"
          :getConnectionList="getConnectionList"
          :updateAnswerRadio="updateAnswerRadio"
          :isSimpleCheckBox="false"
          :connection="connection"
          v-for="(connection, index) in getConnectionList()"
          :key="connection.text"
          @click="updateAnswerRadio(connection)"
          @sendRefCheckBox="collectCheckBoxes"
        />
      </section>
    </div>
    <div
      v-if="getContactsQuiz?.contacts?.phone?.bool"
      :class="style.printContacts"
    >
      <span>Введите телефон</span>
      <div>
        <input
          type="text"
          v-if="['Телеграм', 'Telegram'].includes(answer?.connection)"
          name="contacts-phone"
          @input="answerInputF($event)"
          placeholder="Введите телефон или ваш ник"
          :style="{paddingLeft: '15px'}"
        />
        <input
          @input="answerInputF($event)"
          :placeholder="getPlaceholder('phone')"
          id="notMask"
          name="contacts-phone"
          type="tel"
          v-else-if="getContactsQuiz.phoneMask"
          :style="{paddingLeft: getContactsQuiz.phoneMask ? '15px' : ''}"
        />
        <PhoneInput
          v-else
          name="contacts-phone"
          type="tel"
          @input="answerInputF($event)"
          @update:modelValue="setContactPhone"
          :placeholderPhone="getPlaceholder('phone')"
          :style="{paddingLeft: getContactsQuiz.phoneMask ? '15px' : ''}"
          :county="getCountryContacts"
        />
        <div
          :class="style.flagIco"
          v-if="
            !['Телеграм', 'Telegram'].includes(answer?.connection) &&
            !getContactsQuiz.phoneMask
          "
        >
          <img
            :src="getInformationCountry(getCountryContacts).flagImg"
            alt=""
          />
          <h2
            v-text="getInformationCountry(getCountryContacts).firstPhoneSymbol"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import russiaFlag from "@/images/flags/russia.svg";
import kzFlag from "@/images/flags/kz.svg";
import PhoneInput from "@/elements/phoneInput/PhoneInput.vue";
import style from "./FormComponent.module.scss";
import CheckBoxRadioButton from "@/elements/quizElements/checkboxRadioButton/CheckBoxRadioButton.vue";
import {defineComponent} from "vue";
import {Contacts, CountryName, Quiz} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "FormComponent",
  components: {CheckBoxRadioButton, PhoneInput},
  data() {
    return {
      style,
      radioInputs: [] as HTMLInputElement[],
      answerInputF:
        this.answerInput ??
        ((event: Event) => {
          console.log("пропс не подгрузился", event);
        })
    };
  },
  props: {
    answerInput: Function,
    answer: Object
  },
  mounted() {
    if (!this.mobileVersion) {
      this.addFormNumbering();
    }
    this.setFirstInputChecked();
  },
  methods: {
    collectCheckBoxes(ref: HTMLInputElement) {
      this.radioInputs.push(ref);

      if (this.radioInputs.length === 1) {
        this.setFirstInputChecked();
      }
    },
    updateAnswerRadio({text}: {text: string}) {
      if (this.answer) {
        this.answer.connection = text;
      }
    },
    setContactPhone(phone: string) {
      if (this.answer) {
        (this.answer as Record<string, string>)["Телефон"] = phone;
      }
    },
    getConnectionList() {
      let connection = this.quiz.questions.filter((item) => {
        return Boolean(item.connection);
      })?.[0]?.connection;
      if (connection) {
        return connection.filter((item) => item.bool);
      }
      return [];
    },
    getBoolConnectionList() {
      let connectionList = this.getConnectionList();
      if (!connectionList) {
        return false;
      }
      if (JSON.stringify(connectionList) == "[]") {
        return false;
      }
      return true;
    },
    getPlaceholder(name: string) {
      const contacts = this.getContactsQuiz?.contacts as {
        [key: string]: {placeholder: string};
      };
      if (contacts?.[name]?.placeholder) {
        return contacts[name]?.placeholder;
      }
      interface rusPlaceholders {
        [key: string]: string;
        name: string;
        email: string;
        phone: string;
      }
      const rusPlaceholders: rusPlaceholders = {
        name: "Введите ваше имя",
        email: "Введите ваш email",
        phone: this.getRegionNumberCountry(contacts as Contacts)
      };
      return rusPlaceholders[name];
    },
    getRegionNumberCountry(contacts: {country?: string}) {
      const countryRegion = contacts.country;
      let phoneNumber = "";

      switch (countryRegion) {
        case "Россия (+7)":
        case "Российская Федерация":
          phoneNumber = "999 999-99-99";
          break;
        case "Казахстан":
        case "Казахстан (+7)":
          phoneNumber = "754 322-12-12";
          break;
      }

      return phoneNumber ?? "";
    },
    getInformationCountry(country: string) {
      interface CountryType {
        phone: string;
        flagImg: string;
        firstPhoneSymbol: string;
      }

      const countryData: CountryType = {
        phone: "777 777-77-77",
        flagImg: russiaFlag,
        firstPhoneSymbol: "+7"
      };
      switch (country) {
        case "Россия (+7)":
        case "Российская Федерация":
          countryData.phone = this.getRegionNumberCountry({country});
          countryData.flagImg = russiaFlag;
          countryData.firstPhoneSymbol = "+7";
          break;
        case "Казахстан":
        case "Казахстан (+7)":
          countryData.phone = this.getRegionNumberCountry({country});
          countryData.flagImg = kzFlag;
          countryData.firstPhoneSymbol = "+7";
          break;
      }

      return countryData;
    },
    setFirstInputChecked() {
      this.$nextTick(() => {
        const first = this.getConnectionList()?.[0];
        if (first && this.getContactsQuiz?.contacts?.connectionList?.bool) {
          console.log(first);
          this.updateAnswerRadio(first);
          this.radioInputs[0].checked = true;
        }
      });
    },
    addFormNumbering() {
      this.$nextTick(() => {
        const formBlock = this.$refs.answerForm;

        if (!formBlock) return;
        let blocks;
        if (Array.isArray(formBlock)) {
          blocks = formBlock[0].querySelectorAll(
            `.${this.style.printContacts}, .${this.style.selectConnection}`
          );
        } else {
          blocks = formBlock.querySelectorAll(
            `.${this.style.printContacts}, .${this.style.selectConnection}`
          );
        }

        blocks.forEach((block, index) => {
          const label = block.querySelector("span");

          if (label && !label.dataset.numbered) {
            label.innerHTML = `
              <span class="${this.style.circleNumber}">${index + 1}</span>
              ${label.innerHTML}
            `;
            label.dataset.numbered = "true";
          }
        });
      });
    },
    normalizeCountry(value: unknown): CountryName {
      if (
        value === "Казахстан" ||
        value === "Казахстан (+7)" ||
        value === "kz" ||
        value === "KZ"
      ) {
        return "Казахстан (+7)";
      }

      return "Россия (+7)";
    }
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    getContactsQuiz() {
      return this.quiz.questions.find((item) => {
        return item.type == "contacts";
      });
    },
    mobileVersion() {
      return this.$quizStore.getMobileVersion;
    },
    getCountryContacts() {
      return this.normalizeCountry(this.getContactsQuiz?.contacts.country);
    }
  }
});
</script>
